import { EventEmitter, OnInit, Output } from "@angular/core";
import { Component, Input } from "@angular/core";
import { AtualizacaoForcadaService } from "src/app/api/module/erp/shared/services/atualizacao-forcada-service.service";

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
})
export class ModalComponent implements OnInit {
  @Input() sizeModal?: any;
  @Input() id?: string = "defaultModalId";
  @Input() titleModal?: any;
  @Input() heigModal?: "margin-top: -187px !important;";
  @Input() hideCloseButton: boolean = false; // Novo input para controlar o botão "X"
  @Output() closeModal = new EventEmitter<void>();
  isModalAberta: boolean = false;

  constructor(
    private atualizacaoForcadaService: AtualizacaoForcadaService,
  ) { }

  ngOnInit() {
    this.atualizacaoForcadaService.fecharModal$.subscribe(() => {
      this.fecharModal();
    });
  }

  fecharModal() {
    const modalElement = document.getElementById(this.id || 'defaultModalId');
    if (modalElement) {
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      this.isModalAberta = false;
      document.body.classList.remove('modal-open');
      document.querySelector('.modal-backdrop')?.remove();
    }
  }

  emitirEventoFechar() {
    this.closeModal.emit();
    this.fecharModal();
  }
}
